<template>
  <div>
    <b-modal :id="ModalId" size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" centered :visible="true" :title="TitleWindow" @ok="this.emitEventOK" @hide="this.emitEventHide" :cancel-title="$t('Shared.BtnCancel')"> 
        <Loading v-bind:IsLoading="this.load" /> 

      <b-row>
        <b-col lg="8" md="8" sm="12">
            <MdSelect
                v-bind:Label="'Administered By'"
                data-field="Therapist"
                v-bind:Options="therapistList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'"
                v-bind:ModelArray="therapistModel"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownTherapist"
            />
        </b-col>
        <b-col lg="4" md="4" sm="12">
            <MdCheckBox
              v-bind:Label="$t('MdNote.Sign')"
              v-bind:ClassProp="'AlignCheck'"
              v-bind:CheckedValue="true"
              v-bind:UncheckedValue="false"
              v-model="isSigned"                   
              v-on:change="onSignPassword"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="8" md="8" sm="12">
             <MdSelect
                v-bind:Label="'Witnessed By'"
                data-field="Witness"
                v-bind:Options="witnessList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'"
                v-bind:ModelArray="witnessModel"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownWitness"
            />
        </b-col>
        <b-col lg="2" md="2" sm="12">
            <MdCheckBox
              v-bind:Label="$t('MdNote.Sign')"
              v-bind:ClassProp="'AlignCheck'"
              v-bind:CheckedValue="true"
              v-bind:UncheckedValue="false"
              v-model="isWitness"                   
              v-on:change="onSignWitness"/>
        </b-col> 
        <b-col lg="2" md="2" sm="12">
            <MdButton
              v-bind:Label="isEditing ? $t('AuditList.UPDATE') : $t('Shared.Add')" 
              v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
              v-bind:IconClass="'ti-plus pr-1'"
              v-on:click="addUpd"
              v-bind:Name="'btn_add'">
            </MdButton>
        </b-col> 
      </b-row>
      
      <MdTitle v-bind:Text="'Assessment'" v-bind:isSubtitle="true" v-bind:Name="'T_Assessment'"/>

      <b-row>
        <b-col md="3" lg="3" sm="12">
            <MdEdit 
              v-bind:Label="$t('Shared.Date')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'date'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="assessmentDateModel">                                     
            </MdEdit>
        </b-col>
        <b-col md="3" lg="3" sm="12">
            <MdEdit 
              v-bind:Label="$t('Shared.Time')"
              v-bind:TypeProp="'time'" 
              v-bind:Name="'time'"
              v-model="assessmentTimeModel">                                     
            </MdEdit>
        </b-col>
        <b-col lg="3" md="3" sm="12">
             <MdSelect
                v-bind:Label="'Route Name'"
                data-field="Route"
                v-bind:Options="routeList"
                v-bind:FieldDescription="'description'"
                v-bind:FieldCode="'code'"
                v-bind:ModelArray="routeModel"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownRoute"
            />
        </b-col>
        <b-col lg="3" md="3" sm="12">
             <MdSelect
                v-bind:Label="'Injection Sites'"
                data-field="InjectionSite"
                v-bind:Options="injectionSiteList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'value'"
                v-bind:ModelArray="injectionSiteModel"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownInjectionSite"
            />
        </b-col>  
      </b-row>

      <MdTitle v-bind:Text="'Notes'" v-bind:isSubtitle="true" v-bind:Name="'T_Notes'"/>

      <b-row>
        <b-col md="12" lg="12">
          <MdMemo
            v-bind:Name="'textarea_notes'"
            v-bind:Rows="'3'"
            v-bind:MaxRows="'6'"
            v-bind:MaxLength="'500'"
            v-model="notesModel"
          />                                     
        </b-col>
      </b-row>

      <MdTitle v-bind:Text="'History'" v-bind:isSubtitle="true" v-bind:Name="'T_History'"/>
      <div class="row">
          <div class="col-md-12">
              <MdTable 
              v-bind:fields="fields"
              v-bind:items="items"
              v-bind:totalRows="totalRows"
              v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
              v-bind:currentPage="currentPage"
              v-bind:perPage="perPage"
              v-bind:FieldsDate="FieldsDateArr"
              v-bind:pageOptions="pageOptions"
              :deleteIconEvent="RemoveAssessment"
              v-bind:VisibleDeleteIcon="true"
              :onRowSelected="onRowSelected"
              :onFiltered="onFiltered"
              :pageChanged="pageChanged"
              :perPageFunction="PerPageFunction">
            </MdTable>
          </div>
        </div>

      <MdPasswordDlg v-if="showSignPassword" 
        v-bind:Type="TypePassWord"
        v-bind:EmployeeCode="EmployeeCodeSelected"
        @getModalPassword="onModalPasswordResult($event)"
    />
    </b-modal>
  </div>
</template>

<script>

import ShowMessage from '@/components/messages/ShowMessage.js'
import Loading from '@/components/template/loading/Loading';
import GlobalService from '@/services/global.service' 
import NoteInjectionAssessments from '@/services/noteinjectionassessment.service'
import EnumService from "@/services/enum.service"; 
import { EventBus } from '@/event-bus.js';
  import Utils from '@/common/utils'

export default {
    name: 'MdInjectionAssessmentNotes',
    mixins: [ShowMessage],
    props: {
     ModalId: String,
     PatientCode:String,
     TitleWindow: String,
     DateFrom:String,    
     RecordId:String,
     RecNo:Number,
     ForUsefromMars:Boolean,
     MarsParam:Object
   },
   components:{Loading},
    data() {
      return {         
        clickOK: false,

        therapistModel: {},
        witnessModel: {},
        routeModel:{},
        assessmentDateModel: Utils.formatterDate(Date(), "LLLL"),
        assessmentTimeModel: Utils.formatTimeHm(Date()),
        injectionSiteModel: null,
        notesModel: null,

        therapistList: [],
        witnessList: [],
        routeList: [],
        injectionSiteList: EnumService.InjectionAssessmentInjectionSites,
        
        isSigned: false,
        isWitness: false,
        showSignPassword: false,
        TypePassWord: '',
        EmployeeCodeSelected: '',

        load: true,
        pendingChanges: false,
        params: {
          HeaderID: null,
          TitleRecNo: null,
          PageSize: 0
        },
        isEditing: false,
        data: {
          "headerId": null,
          "assessmentDate": null,
          "assessmentTime": null,
          "therapistCode": null,
          "isSigned": null,
          "sysDate": null,
          "sysUser": null,
          "patientCode": null,
          "titleRecNo": null,
          "injectionSite": null,
          "notes": null,
          "witnessCode": null,
          "route": null,
          "isSignedWitness": null
        },
        items: [],
        fields: [
          { key: 'assessmentDate', sortable: true, label: this.$tc('Shared.Date'), class: 'text-rigth' },
          { key: 'assessmentTime', sortable: true, label: this.$t('Shared.Time'), class: 'text-rigth' },
          { key: 'injectionSite', sortable: true, label: 'Injection Site', class: 'text-rigth' },   
          { key: 'therapistCode', sortable: true, label: 'Administered By', class: 'text-rigth' },       
          { key: 'witnessCode', sortable: true, label: 'Witnessed By', class: 'text-center hidden' },
        ],
        FieldsDateArr:['assessmentDate'],
        ShowMessageIsEmpty:false,
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        filter: null,
        filterOn: [],
        recNo: null
      }
    },
    
    methods:{

      RemoveAssessment(item){
        const RecNo = item.recNo
      this.$bvModal.msgBoxConfirm('This Assessment will be deleted permanently', {
        title: 'Delete Assessment',
        okTitle: this.$t('Shared.TitleDelete'),
        cancelTitle: this.$t('Shared.BtnCancel'),
        footerClass: 'p-2',
        titleClass: 'modal-title modal-type-warning'
      })
      .then(value => {
        if(value){
            NoteInjectionAssessments.Delete(RecNo)
            .then(() => {
              this.getNoteInjectionAssessments();
            })
            .catch((error) => {
              if (!error.response) {
                // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToDelete'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
        }
      })
      },

      pageChanged (page) {            
        this.currentPage = page;    
        this.getNoteInjectionAssessments();     
      },

      PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.getNoteInjectionAssessments();  
      },

      onRowSelected(items) {    
        this.selected = items;

        this.isSigned = items.length > 0 && items[0].isSigned == 'Y' ? true : false
        this.isWitness = items.length > 0 && items[0].isSignedWitness == 'Y' ? true : false
        
        if (items.length > 0) {
          this.isEditing = true

          this.recNo = items[0].recNo
          this.therapistModel = this.therapistList.find(x => x.code == items[0].therapistCode);
          this.witnessModel =  this.therapistList.find(x => x.code == items[0].witnessCode);
          this.routeModel = this.routeList.find(x => x.code == items[0].route);
          this.injectionSiteModel = this.injectionSiteList.find(x => x.value == items[0].injectionSite);
          this.assessmentDateModel = Utils.formatterDate(items[0].assessmentDate)
          this.assessmentTimeModel = items[0].assessmentTime
          this.notesModel = items[0].notes
        } else {
          this.isEditing = false

          this.recNo = null
          this.therapistModel = {}
          this.witnessModel = {}
          this.routeModel = {}
          this.injectionSiteModel = {}
          this.assessmentDateModel = null
          this.assessmentTimeModel = null
          this.notesModel = null
        }
      },

      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },

      onModalPasswordResult(result) {        
        if(result.type === 'Sign'){
          if(result.status !== true) {
            this.showMessage(this.$t('Shared.VerifyPassword'),result.message,"error");
            this.isSigned = false;
          }else{
            this.isSigned = true;
          }
        }

         if(result.type === 'Witness'){
          if(result.status !== true) {
            this.showMessage(this.$t('Shared.VerifyPassword'),result.message,"error");
            this.isWitness = false;
          }else{
            this.isWitness = true;
          }
        }
        this.showSignPassword = false;      
      },

      onSignPassword(value) {
        this.TypePassWord = 'Sign';
        this.EmployeeCodeSelected = value ? this.therapistModel.code : '';
        this.showSignPassword = value;        
        this.isSigned = value;
      },

      onSignWitness(value) {
        this.TypePassWord = 'Witness';
        this.EmployeeCodeSelected = value ? this.witnessModel.code : '';
        this.showSignPassword = value;        
        this.isWitness = value;
      },

      async getEmployees(){
           await GlobalService.getEmployeeActive()
                .then((response) => {
                    if(response.status == '200'){
                        this.witnessList = response.data;
                        this.therapistList = response.data;
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
      },

       async getNoteInjectionAssessments(){
           this.params.HeaderID = this.RecordId.trim(),
           this.params.TitleRecNo = this.RecNo
           this.params.PageSize = this.perPage;

           await NoteInjectionAssessments.getAll(this.params)
                .then((response) => {
                    if(response.status == '200'){
                      this.items = response.data
                      this.items.forEach(function(element) {
                        let { assessmentDate, assessmentTime } = element
                        if (assessmentDate) element.assessmentDate = Utils.formatterDateToString(assessmentDate);  
                        if (assessmentTime) element.assessmentTime = Utils.formatterTimeToString(assessmentTime);        
                      });
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
      },

      addUpd() {
         if (!this.isEditing) {
            this.addNoteInjectionAssessments()
          } else {
            this.UpdNoteInjectionAssessments()
          }
      },

      async addNoteInjectionAssessments(){
           this.data.headerId = this.RecordId.trim(),
           this.data.therapistCode = this.therapistModel.code
           this.data.isSigned = 'Y'
           this.data.witnessCode = this.witnessModel.code
           this.data.isSignedWitness = 'Y'
           this.data.patientCode = this.PatientCode
           this.data.titleRecNo = this.RecNo
           this.data.assessmentDate = this.assessmentDateModel
           this.data.assessmentTime = Utils.formatterShortTimeToIso(this.assessmentTimeModel) 
           this.data.injectionSite = this.injectionSiteModel.value
           this.data.notes = this.notesModel
           this.data.route = this.routeModel.code

           await NoteInjectionAssessments.Add(this.data)
                .then((response) => {
                    if(response.status == '200'){
                        this.getNoteInjectionAssessments()
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
      },

      async UpdNoteInjectionAssessments(){
           this.data.headerId = this.RecordId.trim(),
           this.data.therapistCode = this.therapistModel.code
           this.data.isSigned = 'Y'
           this.data.witnessCode = this.witnessModel.code
           this.data.isSignedWitness = 'Y'
           this.data.patientCode = this.PatientCode
           this.data.titleRecNo = this.RecNo
           this.data.assessmentDate = this.assessmentDateModel
           this.data.assessmentTime = Utils.formatterShortTimeToIso(this.assessmentTimeModel) 
           this.data.injectionSite = this.injectionSiteModel.value
           this.data.notes = this.notesModel
           this.data.route = this.routeModel.code

           await NoteInjectionAssessments.Update(this.recNo,this.data)
                .then((response) => {
                    if(response.status == '200'){
                        this.getNoteInjectionAssessments()
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
      }, 

      async getRouteName(){          
            var param = {
                CodeType:"ROUTE",
                GroupCreation:"SIG"
            };     
            await GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.routeList = response.data; 
                        this.routeList.forEach(element => {           
                            element.code = element.description;                 
                        });
                    }                   
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);                   
                });        
        },

      ChangeDropDownTherapist(value) {
        if(value){
          this.therapistModel = value;  
          this.isSigned = false;    
        }else{
          this.therapistModel = {
            "code": "",
            "firstName": "",
            "fullName": "",
            "lastName": "",
          }
          this.isSigned = false;
        } 
      },

      ChangeDropDownWitness(value) {
         if(value){
          this.witnessModel = value;  
          this.isWitness = false;    
        }else{
          this.witnessModel = {
            "code": "",
            "firstName": "",
            "fullName": "",
            "lastName": "",
          }
          this.isWitness = false;
        } 
      },

      ChangeDropDownRoute(value) {
        if(value){
          this.routeModel = value;  
        }else{
          this.routeModel = {
            "code": "",
            "description": "",
          }
        }
      },

      ChangeDropDownInjectionSite(value) {
        if(value){
          this.injectionSiteModel = value;  
        }else{
          this.injectionSiteModel = {
            "value": "",
            "name": "",
          }
        }
      },

      Save(handled) {
        let abortSave = false
        if (!this.isSigned || !this.isWitness) {
          this.showMessage(this.$tc('Msg.Error'), this.$t('MdPainAssessmentNotesOutCome.SingBeforeMsg'),"error");
          abortSave = true
          handled.preventDefault()
        }

        if (this.therapistModel && this.therapistModel.code == this.witnessModel.code) {
          this.showMessage(this.$tc('Msg.Error'), 'Administrator and witness cannot be the same',"error");
          abortSave = true
          handled.preventDefault()
        }
        this.clickOK = false
        
        if (!abortSave) {
          this.addUpd()
        }

        this.$emit('getCodeConditionOK');
      },

      emitEventOK(){ 
        this.clickOK = true;    
      },

      emitEventHide(handled){
        if (this.pendingChanges && !this.clickOK) {
        handled.preventDefault()
        this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.TitleWindow,
          okTitle: this.$t('Shared.Save'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(value => {
            if(!value){
              this.$emit('getCancel');
              this.ResetProps();
            } else {
              this.Save(handled)
            }
          })		
        } else {
            if(this.clickOK) {
              this.Save(handled)
            } else {
                this.$emit('getCancel');
                this.ResetProps();
            }
        }
      },

      ResetProps(){
        
      },

      beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''	
			}
		}
    },

  async mounted() {
    await this.getEmployees()
    await this.getRouteName()
    await this.getNoteInjectionAssessments()
  },

  created () {
     EventBus.$on("onChanged", function (e) {       
          this.pendingChanges = e.Changed
     }.bind(this));
     window.addEventListener('beforeunload', this.beforeWindowUnload)
  },

  beforeDestroy () {
  },
}

</script>